import { autoTranslate } from "@web-monorepo/vite-auto-translate-plugin/runtime";
import { connect } from "react-redux";
import { compose } from "recompose";
import { Radio, RadioChannel, sendRadio } from "src/pods/radio";
import active from "src/pods/radio/assets/active.svg";
import calm from "src/pods/radio/assets/katie_reading.png";
import {
  displayClose,
  displayOpen,
  RealtimeState,
  remoteClose,
  selectDisplayOn,
  selectPaired,
} from "src/pods/realtime";
import withRouteParams from "src/shared/hoc/withRouteParams";
import RadioRemote from "./RadioRemote";

type RadioRemoteState = {
  radio: Radio;
} & RealtimeState;

const mapStateToProps = (state: RadioRemoteState) => {
  const channels: RadioChannel[] = [
    {
      title: autoTranslate("Focus"),
      icon: calm,
      tracks: Array.from({ length: 5 }, (_, n) => ({
        src: `https://static.classdojo.com/toolkit-static/radio/calm_${n + 1}.mp3`,
      })),
    },
    {
      title: autoTranslate("Active"),
      icon: active,
      tracks: Array.from({ length: 5 }, (_, n) => ({
        src: `https://static.classdojo.com/toolkit-static/radio/upbeat_${n + 1}.mp3`,
      })),
    },
  ];

  return {
    channels,
    isCasting: selectPaired(state) && selectDisplayOn(state),
    ...state.radio,
  };
};
const mapDispatchToProps = { displayOpen, displayClose, remoteClose, sendRadio };

export default compose<any, any>(
  withRouteParams(["classId", "mountPoint"]),
  connect(mapStateToProps, mapDispatchToProps),
)(RadioRemote);
